import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "project-rowwrap" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "project-info mb-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", null, "Total Sent Referal", -1)
const _hoisted_7 = { class: "card export-wrap" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-sm-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "All Share URL"),
  /*#__PURE__*/_createVNode("p", { class: "mb-sm-0" }, [
    /*#__PURE__*/_createVNode("small", null, "Share URL.")
  ])
], -1)
const _hoisted_10 = { class: "col-sm-2" }
const _hoisted_11 = { class: "text-sm-right" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-export mr-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Back ")
const _hoisted_14 = { class: "card p-0" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-shadowed table-relative mb-0" }
const _hoisted_17 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status")
  ])
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, "Join", -1)
const _hoisted_21 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "badge badge-danger" }, "Send", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { colspan: 5 }
const _hoisted_25 = { class: "modal-wrap default-modal lg-size" }
const _hoisted_26 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Invite member "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "form-wrap pt-0" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite by Email", -1)
const _hoisted_36 = { class: "input-btn" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_41 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("p", null, _toDisplayString(_ctx.state.userList.length), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("a", {
              href: "javascript:void(0)",
              type: "button",
              class: "btn default-btn d-inline-block",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectBack && _ctx.redirectBack(...args)))
            }, [
              _hoisted_12,
              _hoisted_13
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode("table", _hoisted_16, [
          _hoisted_17,
          (_ctx.state.userList.length)
            ? (_openBlock(), _createBlock("tbody", _hoisted_18, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (user, userIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: userIndex }, [
                    _createVNode("td", null, _toDisplayString(user.email), 1),
                    _createVNode("td", null, [
                      (user.is_complete === 1)
                        ? (_openBlock(), _createBlock("p", _hoisted_19, [
                            _hoisted_20
                          ]))
                        : _createCommentVNode("", true),
                      (user.is_complete === 0)
                        ? (_openBlock(), _createBlock("p", _hoisted_21, [
                            _hoisted_22
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_23, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_24, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_31
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.inviteMember = $event)),
                      type: "email",
                      class: "form-control",
                      id: "exampleInputEmail1",
                      "aria-describedby": "emailHelp",
                      placeholder: "Type email and press enter or click add button",
                      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.inviteMember]
                    ]),
                    _createVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                    }, [
                      _hoisted_37
                    ])
                  ]),
                  (_ctx.state.data.verifyMessage)
                    ? (_openBlock(), _createBlock("p", _hoisted_38, [
                        _createVNode("small", null, _toDisplayString(_ctx.state.data.verifyMessage), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invites, (invite, inviteIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      key: inviteIndex,
                      class: "email-tag"
                    }, [
                      _createVNode("p", _hoisted_39, [
                        _createTextVNode(_toDisplayString(invite) + " ", 1),
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                        }, [
                          _hoisted_40
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_41, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendInviteMember && _ctx.sendInviteMember(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.sendInvitation
                    ? "Inviting..."
                    : "Send"), 1),
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn secondary-btn mr-2",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args)))
                  }, "Close")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}